import React from 'react';
import { Folder, X } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import { Button } from '../ui/button';

export const AlbumMultiSelect = ({ folders, visible, selected, setSelected, disabled }) => {
  const toggle = (id, checked) => setSelected(ids => checked
    ? [...new Set([...ids, id])] : ids.filter(value => value !== id));
  return <div className="space-y-3 min-w-0">
    <div data-testid="required-share-albums" className="space-y-2 max-h-64 overflow-y-auto">
      {visible.length === 0 && <p data-testid="required-share-empty" className="text-sm text-slate-500 py-4">
        {folders.length ? 'No matching albums.' : 'No product albums are available. Ask an administrator to add an album, then refresh.'}
      </p>}
      {visible.map(folder => <label key={folder.id} htmlFor={`select-album-${folder.id}`}
        className={`w-full flex items-center gap-3 border rounded-lg p-3 text-left cursor-pointer hover:border-amber-400 hover:bg-amber-50 transition-colors ${selected.includes(folder.id) ? 'border-green-500 bg-green-50/60' : folder.recommended ? 'border-amber-300 bg-amber-50/60' : 'border-slate-200'} ${disabled ? 'opacity-50 cursor-wait' : ''}`}>
        <Checkbox id={`select-album-${folder.id}`} data-testid={`required-share-album-${folder.id}`}
          checked={selected.includes(folder.id)} onCheckedChange={checked => toggle(folder.id, checked === true)} disabled={disabled}
          aria-label={`Select ${folder.name}`} className="shrink-0" />
        <Folder className="w-5 h-5 text-amber-600 shrink-0" />
        <span className="text-sm font-medium flex-1 min-w-0 break-words [overflow-wrap:anywhere]">{folder.name}
          {folder.recommended && <span data-testid={`recommended-album-${folder.id}`} className="block text-xs font-normal text-amber-700 mt-1">
            Suggested · {folder.matchedKeywords.join(', ')}
          </span>}
        </span>
      </label>)}
    </div>
    <div className="flex items-center justify-between gap-3">
      <span role="status" data-testid="required-share-selection-count" className="text-sm font-medium text-slate-700">
        {selected.length} {selected.length === 1 ? 'album' : 'albums'} selected
      </span>
      {selected.length > 0 && <Button type="button" size="icon" variant="ghost" disabled={disabled}
        data-testid="required-share-clear-selection" title="Clear selection" aria-label="Clear selected albums" onClick={() => setSelected([])}>
        <X className="w-4 h-4" />
      </Button>}
    </div>
    {selected.length > 0 && <p data-testid="required-share-selected-names" className="text-xs text-slate-500 break-words [overflow-wrap:anywhere]">
      {selected.map(id => folders.find(folder => folder.id === id)?.name).filter(Boolean).join(' · ')}
    </p>}
  </div>;
};